export default () => {
    const category = $(".type-category").length;

    if (category) {
        const initCategory = () => {
            $(".carousel-wrapper").insertBefore(".breadcrumbs");
            $(".stripe").insertBefore("#footer");
            $(".instagram").insertBefore("#footer");
        };

        initCategory();
    }
};